// Lib
import React from 'react';
import type { MutableRefObject } from 'react';
import { ActionMenu, resolveMenuItems } from '@milanote/roma/application';
import type { ActionMenuConfig } from '@milanote/roma/application';
import type { MenuSize } from '@milanote/roma';

// Utils
import { isGlobalDebugEnabled } from '../../../../../debug/debugUtil';
import { useTranslator } from '../../../../../components/i18n/useTranslator';
import { tableContextMenuV2Config } from './tableContextMenuV2Config';

// Types
import type { MNHotInstance } from '../../../bridge/tableHotInstanceTypes';
import type { TableContextMenuV2Context } from './tableContextMenuV2Config';

type TableContextMenuV2Props = {
    hotTableInstanceRef: MutableRefObject<MNHotInstance | null>;
    locale: string;
    elementId: string;
    runGridAction: TableContextMenuV2Context['runGridAction'];
    runClipboardAction: TableContextMenuV2Context['runClipboardAction'];
    menuConfig?: ActionMenuConfig<TableContextMenuV2Context>;
    size?: MenuSize;
};

/** Renders the table cell action registry against the current Handsontable selection. */
const TableContextMenuV2: React.FC<TableContextMenuV2Props> = ({
    hotTableInstanceRef,
    locale,
    elementId,
    runGridAction,
    runClipboardAction,
    menuConfig = tableContextMenuV2Config,
    size = 'xs',
}) => {
    const translate = useTranslator('canvas', 'contextMenuItems.table') as (localeKey: string) => string;

    const hotInstance = hotTableInstanceRef.current;
    if (!hotInstance) return null;

    const context: TableContextMenuV2Context = {
        translate,
        locale,
        elementId,
        hotInstance,
        showDebugTools: isGlobalDebugEnabled(),
        runGridAction,
        runClipboardAction,
    };
    const nodes = resolveMenuItems(menuConfig, context);

    return <ActionMenu.Content aria-label="Table cell actions" nodes={nodes} autoFocus size={size} />;
};

export default TableContextMenuV2;
